export default __webpack_public_path__ + "static/media/kitchen3-afterD-1440w.a4cb0c8c.webp";